import Vue from 'vue';
import { VueJsonp } from 'vue-jsonp';
import Vuex from 'vuex';
import App from './app.vue';
import { createStore } from './store';
import { createRouter } from './router';
import { sync } from 'vuex-router-sync';
import ImgLoader from '@/marketing_components/img-loader'; // ./components/img-loader
import message from '@/marketing_components/message'; // ./components/message
import VueLazyComponent from './components/vue-lazy-component/index.js'; // @TODO
import VueClipboard from 'vue-clipboard2';
import { Toast, Cell, MessageBox } from 'mint-ui';
import 'mint-ui/lib/style.css';
import tracker from '@/util/report/tracker';
import { initializeFm } from './util/fm.js';

Vue.use(Vuex);
Vue.use(VueJsonp);
Vue.use(VueLazyComponent);
Vue.use(VueClipboard);
Vue.component(Toast.name, Toast);
Vue.component(Cell.name, Cell);
Vue.component('img-loader', ImgLoader);
Vue.component('message', message);
Vue.prototype.$message = message;
// 埋点
Vue.prototype.$tracker = tracker;
Vue.$messagebox = Vue.prototype.$messagebox = MessageBox;
Vue.$toast = Vue.prototype.$toast = Toast;
if (process.browser) {
    const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');
    Vue.use(VueAwesomeSwiper);
    initializeFm();
}

export function createApp(host) {
    const store = createStore();
    const router = createRouter();
    sync(store, router);
    const app = new Vue({
        router,
        store,
        render: h => h(App)
    });
    // 全局-请求方法
    Promise.all([store.dispatch('rules', { host: host })]).then(() => {
        Vue.prototype.$accountMobileRule = store.state.rulesData;
    });
    return {
        app,
        router,
        store
    };
}



// WEBPACK FOOTER //
// ./src/app.js